import { ReactElement } from 'react';
import { Categories } from '@client/catalog/components/Categories';
import { Facets } from '@client/catalog/components/Facets';
import {
  Props,
} from './CatalogFilters.types';

export const CatalogFilters = ({
  categories,
  isLevelZeroAvailable = false,
  availableFacetFilters,
  onCategoryChange,
  onFacetFilterCheckboxChange,
  onFacetFilterRangeChange,
}: Props): ReactElement => (
  <>
    <Categories
      isLevelZeroAvailable={isLevelZeroAvailable}
      categories={categories}
      onChange={onCategoryChange}
    />

    <Facets
      filters={availableFacetFilters}
      onFilterCheckboxChange={onFacetFilterCheckboxChange}
      onFilterRangeChange={onFacetFilterRangeChange}
    />
  </>
);
